module.exports = __webpack_public_path__ + "static/media/MANAS 3.d2bf7570.jpg";